import { ASSETS } from "@/data/site";

const Card = ({ children, bg, testId }) => (
  <div
    data-testid={testId}
    className="relative overflow-hidden rounded-2xl shadow-2xl"
    style={{ width: 1050, height: 600, background: bg, maxWidth: "100%" }}
  >
    {children}
  </div>
);

export default function BusinessCard() {
  return (
    <main className="min-h-screen bg-ivory pt-32 pb-24" data-testid="business-card-page">
      <div className="mx-auto max-w-6xl px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-sienna">Print-ready · 3.5″ × 2″</p>
        <h1 className="mt-4 font-serif text-5xl font-light text-espresso">
          Your <span className="italic text-sienna">business card</span>
        </h1>
        <p className="mt-4 max-w-xl text-base text-cocoa">
          Front and back, built from your logo and brand. Save them as images or ask me for
          a print-ready PDF.
        </p>

        <div className="mt-12 space-y-12">
          <div>
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.25em] text-cocoa/60">Front</p>
            <Card bg="#A28A8A" testId="card-front">
              <img
                src="/images/card-front.jpg"
                alt="inbornbirth"
                className="absolute inset-0 h-full w-full object-cover"
                data-testid="card-front-logo"
              />
            </Card>
          </div>

          <div>
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.25em] text-cocoa/60">Back</p>
            <Card bg="#2B1D18" testId="card-back">
              <div className="flex h-full items-center gap-14 px-16">
                <div
                  className="h-64 w-64 shrink-0 overflow-hidden rounded-full ring-1 ring-[#F9F6F0]/25"
                  data-testid="card-back-photo"
                >
                  <img
                    src={ASSETS.portrait2}
                    alt="Athena"
                    className="h-full w-full object-cover"
                  />
                </div>
                <div className="text-left">
                  <p className="font-roman text-3xl tracking-[0.22em] text-[#F9F6F0]" data-testid="card-back-wordmark">
                    <span className="mr-2 text-[#A65628]">☾</span>ɪɴʙᴏʀɴ<span className="text-[#C4956B]">ʙɪʀᴛʜ</span><span className="ml-2 text-[#A65628]">☽</span>
                  </p>
                  <p className="mt-2 text-xs uppercase tracking-[0.35em] text-[#F9F6F0]/60">
                    Traditional · Womb · Postpartum
                  </p>
                  <div className="my-6 h-px w-32 bg-[#F9F6F0]/20" />
                  <p className="font-serif text-2xl italic text-[#C4956B]">
                    Preparation for the Fourth Trimester
                  </p>
                  <p className="mt-5 text-base text-[#F9F6F0]/80">
                    Athena · Sacred Postpartum Companion
                  </p>
                  <p className="mt-2 text-sm text-[#F9F6F0]/60">
                    athena@inbornbirth.com
                  </p>
                  <p className="mt-1.5 text-sm text-[#F9F6F0]/60">
                    Northern Colorado · Virtual wherever you are
                  </p>
                  <p
                    className="mt-5 inline-block rounded-full border border-[#C4956B]/60 px-5 py-1.5 font-roman text-lg tracking-[0.2em] text-[#C4956B]"
                    data-testid="card-back-website"
                  >
                    inbornbirth.com
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </main>
  );
}
